<div mat-dialog-title class="flex flex-row items-center justify-between border-b border-gray-200 px-6 py-2 mb-4">
  <h3 class="flex-1 m-0 font-semibold">{{ 'poi.category.categoryCantBeDeleted' | translate }}</h3>
  <flow-button class="absolute right-4 top-3" theme="light" type="button" [mat-dialog-close]="true">
    <app-icon stroke="#202020" size="md" iconName="x"></app-icon>
  </flow-button>
</div>

<mat-dialog-content class="overflow-hidden px-6">
  <div>
    <div>{{ 'poi.category.categoryInUse' | translate }}</div>
    <div class="mt-2">
      {{ 'poi.category.usedPois' | translate }}
      <ul class="list-disc ml-10 mt-1">
        <li class="font-bold" *ngFor="let poi of pois">{{poi.name}}</li>
      </ul>
    </div>
  </div>
</mat-dialog-content>

<div mat-dialog-actions class="flex flex-row justify-between w-full items-center p-6 pt-0">
  <flow-button theme="secondary" variation="outline" [mat-dialog-close]="true">{{'global.cancel' | translate}}</flow-button>
</div>
